/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Allocations_Empty_State_TitleInputs */

const en_admin_dashboard_allocations_empty_state_title = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Good!`)
};

const de_admin_dashboard_allocations_empty_state_title = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles bestens!`)
};

const es_admin_dashboard_allocations_empty_state_title = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Todo en orden!`)
};

const fr_admin_dashboard_allocations_empty_state_title = /** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout est en ordre !`)
};

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */
const it_admin_dashboard_allocations_empty_state_title = en_admin_dashboard_allocations_empty_state_title;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */
const pt_br2_admin_dashboard_allocations_empty_state_title = en_admin_dashboard_allocations_empty_state_title;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */
const pl_admin_dashboard_allocations_empty_state_title = en_admin_dashboard_allocations_empty_state_title;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */
const hu_admin_dashboard_allocations_empty_state_title = en_admin_dashboard_allocations_empty_state_title;

/** @type {(inputs: Admin_Dashboard_Allocations_Empty_State_TitleInputs) => LocalizedString} */
const ro_admin_dashboard_allocations_empty_state_title = en_admin_dashboard_allocations_empty_state_title;

/**
* | output |
* | --- |
* | "All Good!" |
*
* @param {Admin_Dashboard_Allocations_Empty_State_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_allocations_empty_state_title = /** @type {((inputs?: Admin_Dashboard_Allocations_Empty_State_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Allocations_Empty_State_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "de") return de_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "es") return es_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "fr") return fr_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "it") return it_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "pl") return pl_admin_dashboard_allocations_empty_state_title(inputs)
	if (locale === "hu") return hu_admin_dashboard_allocations_empty_state_title(inputs)
	return ro_admin_dashboard_allocations_empty_state_title(inputs)
});
export { admin_dashboard_allocations_empty_state_title as "admin.dashboard.allocations_empty_state_title" }